import TableComponent from "components/Table"
import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import { Col, Row } from "reactstrap"
import { getEventInviteList } from "store/actions"
import usersListColumns from "./usersListColumns"

const UsersModal = ({
  eventInviteList,
  getEventInviteList,
  vendorId,
  eventId,
}) => {
  const [defaultOrder, setDefaultOrder] = useState({
    o: "name",
    od: "asc",
  })

  const handlePageChange = page => {
    getEventInviteList(vendorId, eventId, {
      page: page,
      perPage: 15,
      ...defaultOrder,
    })
  }

  const handleSort = (type, { sortField, sortOrder }) => {
    getEventInviteList(vendorId, eventId, {
      o: sortField,
      od: sortOrder,
      perPage: 15,
      page: 1,
    })
    setDefaultOrder({ o: sortField, od: sortOrder })
  }

  return (
    <React.Fragment>
      <Row style={{ height: "500px" }}>
        <Col>
          <TableComponent
            keyField="user_id"
            data={eventInviteList?.data}
            columns={usersListColumns()}
            paginationData={{
              current_page: eventInviteList?.current_page,
              last_page: eventInviteList?.last_page,
              total_items: eventInviteList?.total,
              items_per_page: eventInviteList?.per_page,
              from: eventInviteList?.from,
              to: eventInviteList?.to,
              first_page: 1,
            }}
            onPageChange={handlePageChange}
            onTableSort={handleSort}
          />
        </Col>
      </Row>
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  eventInviteList: state.experiences.eventInviteList,
  vendorId: state.Login.vendorId,
})

const mapDispatchToProps = dispatch => ({
  getEventInviteList: (vendorId, eventId, sortOptions) =>
    dispatch(getEventInviteList(vendorId, eventId, sortOptions)),
})

export default connect(mapStateToProps, mapDispatchToProps)(UsersModal)
